import { rest } from "msw";
import { mockBOM } from "./bom.mocks";
export const bomHandlers = [
    // GET /product-assembly/product/:id 형태의 path params 처리
    rest.get("/product-assembly/commercial/product/:id", (req, res, ctx) => {
        const { id } = req.params;
        const productId = Number(id);
        const children = Number.isFinite(productId)
            ? (mockBOM.find((bom) => bom.id === productId)?.children ?? [])
            : [];
        return res(ctx.status(200), ctx.json(children));
    }),
];
